
import { FormCreateUpdateGalpon } from "../../components";
import { DisenioPaginas } from "../../layout";







export const CrearGalpon = () => {


    const initialState = {
        nombre: '',
        cantidad: '',
        genero: '',
        granja: '',
        alto: '',
        largo: '',
        ancho: '',
    }



    return (


        <DisenioPaginas titulo="Crear Galpon" url={1} add={false} subtitulo="Información del galpon">
            <FormCreateUpdateGalpon initialState={initialState} />
        </DisenioPaginas>

    )
}
